import { Languages } from '../../../../../../interfaces/common'

export const getSmartCaptchaLanguage = (language: Languages) => {
  if (language === Languages.UZ) {
    return 'uz'
  }

  return 'ru'
}
